export enum OrderSetupType {
    NONE,
    ACCOUNT,
    ORDERTEMPLATE,
    QUOTATION,
    CONTRACT,
    ORDERNAME,
}
